// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partnership-circle-value-container {
  display: flex;
  align-items: center;
  position: relative;
  cursor: default;
}
.partnership-circle-value-container .partnership-circle-value-data-box-floater {
  position: absolute;
  top: 0;
  right: 0;
  padding: 30px;
  width: 350px;
}
.partnership-circle-value-container .partnership-circle-value-data-box {
  padding: 10px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 9px 25px 0 rgba(129, 155, 163, 0.2705882353);
}
.partnership-circle-value-container .partnership-circle-value {
  margin-left: 5px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/PartnershipCategoryValue/PartnershipCategoryValue.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AACD;AACC;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;AACF;AACC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0DAAA;AACF;AAEC;EACC,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF","sourcesContent":[".partnership-circle-value-container {\n\tdisplay: flex;\n\talign-items: center;\n\tposition: relative;\n\tcursor: default;\n\n\t.partnership-circle-value-data-box-floater {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tpadding: 30px;\n\t\twidth: 350px;\n\t}\n\t.partnership-circle-value-data-box {\n\t\tpadding: 10px;\n\t\tbackground-color: white;\n\t\tborder-radius: 10px;\n\t\tbox-shadow: 0 9px 25px 0 #819BA345;\n\t}\n\n\t.partnership-circle-value {\n\t\tmargin-left: 5px;\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tborder-radius: 50%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
